export default __webpack_public_path__ + "static/media/logo.b0184e46.png";